<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">
    {{ 'ADMINISTRATION_AVANCEE.MODIFIER_NUMERO_EMPLOYE.TITLE' | translate }}
  </h2>

  <div class="mb-6">
    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.MODIFIER_NUMERO_EMPLOYE.NOVO_ENTITE_ID' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="novoEntiteId" [disabled]="isLoading">
    </mat-form-field>

    <div
      class="border-2 border-dashed border-gray-500 rounded-lg p-6 cursor-pointer hover:border-blue-500 transition-colors mb-4"
      (click)="fileInput.click()" [style.pointer-events]="isLoading ? 'none' : 'auto'"
      [style.opacity]="isLoading ? '0.6' : '1'">
      <input #fileInput type="file" accept=".csv,.txt" (change)="onFileSelected($event)" hidden>
      <div class="text-center">
        <mat-icon class="text-4xl text-gray-300 mb-2 block">cloud_upload</mat-icon>
        <p class="text-sm font-medium text-gray-300">
          {{ 'ADMINISTRATION_AVANCEE.MODIFIER_NUMERO_EMPLOYE.DROP_FILE' | translate }}
        </p>
        @if (fileName) {
          <p class="text-xs text-gray-400 mt-1">
            {{ fileName }}
          </p>
        }
        <p class="text-xs text-gray-500 mt-2">
          {{ 'ADMINISTRATION_AVANCEE.MODIFIER_NUMERO_EMPLOYE.CSV_FORMAT' | translate }}
        </p>
      </div>
    </div>

    <div class="flex items-center gap-4">
      <button mat-raised-button (click)="mettreAJour()"
        [disabled]="isLoading || !novoEntiteId || utilisateurs.length === 0"
        class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
        @if (!isLoading) {
          <mat-icon>save</mat-icon>
        }
        @if (isLoading) {
          <mat-spinner diameter="20" class="inline-block mr-2"></mat-spinner>
        }
        {{ 'COMMUN.SAVE' | translate }}
      </button>

      <button mat-stroked-button (click)="resetForm()" [disabled]="isLoading" class="text-white border-white">
        {{ 'COMMUN.CANCEL' | translate }}
      </button>
    </div>
  </div>
</div>
